import type { ColophonContent } from "../types";

export const colophon: ColophonContent = {
  linePrefix: "Lavet med",
  lineSuffix: "og UCloud AI.",
  finePrint:
    "AI-drevet, menneskeledet. Enhver token er beregnet i Danmark, " +
    "aldrig brugt til træning.",
};
